import { Trans } from 'react-i18next';
const PrivacyField: React.FC = () => {
  return (
    <div className='form-field'>
      <label className='checkbox' htmlFor='register-privacy'>
        <input type='checkbox' id='register-privacy' name='register-privacy' required />
        <span>
          <Trans
            i18nKey='shared.privacy'
            components={{
              a: <a href='https://www.aeb.com/de-de/datenschutz.php' target='_blank' rel='noopener noreferrer' />,
            }}
          />
        </span>
      </label>
    </div>
  );
};

export default PrivacyField;
